module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_02b.3729168b.jpg";